module.exports = __webpack_public_path__ + "img/Petite_decoration.0edac20.jpg";